// NavigationContext.js
import { createContext, useContext, useState } from 'react';

const NavigationContext = createContext();

const pathToActivePage = {
  '/queueworkflow': 'queueWorkflow',
  '/nextworkitem': 'nextWorkitem',
  '/newworkitem': 'newWorkitem',
  '/newdocument': 'newDocument',
  '/documentsearch': 'viewMenu',
  '/completed': 'completed',
  '/newwalkin': 'newwalkin',
  '/caseview': 'caseView',
  '/myytrac': 'myytrac',
};

const getInitialActivePage = () => {
  const path = window.location.pathname.toLowerCase();
  return pathToActivePage[path] ?? 'newDocument';
};

export function NavigationProvider({ children }) {
  const [activePage, setActivePage] = useState(getInitialActivePage);
  const [isFormContentChanged, setIsFormContentChanged] = useState(false);
  const [dialogContent, setDialogContent] = useState([]);

  const propsForProvider = {
    activePage,
    setActivePage,
    isFormContentChanged,
    setIsFormContentChanged,
    dialogContent,
    setDialogContent
  };

  return (
    <NavigationContext.Provider value={propsForProvider}>
      {children}
    </NavigationContext.Provider>
  );
}

export function useNavigationContext() {
  return useContext(NavigationContext);
}